import React from 'react'
import Navbar from '../inc/Navbar'
import frontshowroom from "../images/balaji.jpeg";

import Interiorphoto from "../images/Interior_photo.jpg";
import Sareecounter from "../images/Saree_counter.jpg";
import bethuadaharishowroom from "../images/showroom opeing bethua.jpg"
import builfingfront from "../images/Building photo front.jpg";

import balajisareebethuadahari from "../images/Balaji Saree_bethuadahari.jpg";


import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import ScrollToTop from "react-scroll-to-top";
import BethuaMap from './BethuaMap';

function Bethuashop() {
    return (
        <div>
            <Navbar />

            <br />
            <br />
            <br />
            <br />

            <ScrollToTop smooth top="100" color="maroon" />
            <div className="album py-2">
                <div className="container">
                    <div className="row">

                        <div className="col-md-12">
                            <div className='topapperalshopbethua'>
                                <img className='img-fluid' src={frontshowroom} alt='frontshowroom' />
                            </div>
                        </div>
                        {/* <div className="col-md-5 mt-0">
                            <div class="accordion" id="accordionExample">
                                <div class="accordion-item">
                                    <h2 class="accordion-header" id="headingOne">
                                        <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                            BALAJI SAREE Bethaudahari
                                        </button>
                                    </h2>
                                    <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                        <div class="accordion-body">
                                            <p style={{ color: "maroon" }} className="card-text mb-1">Patuli Ghat Rd, Bethuadahari, West Bengal 741126 | India

                                            </p>


                                            <a href='tel: 9144500550'>+91 9144500550</a>
                                        </div>
                                    </div>
                                </div>
                                <div class="accordion-item">
                                    <h2 class="accordion-header" id="headingTwo">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                            Direction Map
                                        </button>
                                    </h2>
                                    <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                                        <div class="accordion-body">

                                            <a href='https://g.co/kgs/qQmimFn' target="_blank" rel="noopener noreferrer">
                                                <p class='mb-2' >Direction <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-sign-turn-right" viewBox="0 0 16 16">
                                                    <path d="M5 8.5A2.5 2.5 0 0 1 7.5 6H9V4.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L9.41 8.658A.25.25 0 0 1 9 8.466V7H7.5A1.5 1.5 0 0 0 6 8.5V11H5z" />
                                                    <path fill-rule="evenodd" d="M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.48 1.48 0 0 1 0-2.098zm1.4.7a.495.495 0 0 0-.7 0L1.134 7.65a.495.495 0 0 0 0 .7l6.516 6.516a.495.495 0 0 0 .7 0l6.516-6.516a.495.495 0 0 0 0-.7L8.35 1.134Z" />
                                                </svg></p>
                                            </a>

                                            <BethuaMap />

                                        </div>
                                    </div>
                                </div>
                                <div class="accordion-item">
                                    <h2 class="accordion-header" id="headingThree">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                            Contact us
                                        </button>
                                    </h2>
                                    <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                                        <div class="accordion-body">


                                            <a href='tel:+91 9144500550'>+91 9144500550</a>
                                        </div>
                                    </div>
                                </div>


                            </div>

                        </div> */}

                    </div>
                </div>
            </div>
            <div className="album py-1">
                <div className="container">
                      <div className="row">

                        <div className="col-md-4">
 <Zoom>
                                            <img src={balajisareebethuadahari} className="card-img-top image2" alt="balajisareebethuadahari"/>
                                        </Zoom>
                            </div>
                            <div className="col-md-8">
                    <div className="card mb-3" >
                        <div className="row g-0">
                            <div className="col-md-4">
                                <img src={builfingfront} className="img-fluid rounded-start" alt="builfingfront" />
                            </div>
                            <div className="col-md-8">
                                <div className="card-body">
                                    <div className='color'>
                                        <h5 className="card-title">Patuli Ghat Rd, Bethuadahari, West Bengal 741126 | India</h5>
                                    </div>
                                    <a className='mb-4' href='tel: +91 9144500550'>+91 9144500550</a>
                                    <a href='https://maps.app.goo.gl/UYkAcia91yK3ZL3D9' target="_blank" rel="noopener noreferrer">
                                        <p className="card-text mt-3">Direction Map <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-sign-merge-right" viewBox="0 0 16 16">
                                            <path d="M8.75 6v1q.211.451.588.95c.537.716 1.259 1.44 2.016 2.196l-.708.708-.015-.016c-.652-.652-1.33-1.33-1.881-2.015V12h-1.5V6H6.034a.25.25 0 0 1-.192-.41l1.966-2.36a.25.25 0 0 1 .384 0l1.966 2.36a.25.25 0 0 1-.192.41z" />
                                            <path fill-rule="evenodd" d="M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098zm-1.4.7a.495.495 0 0 1 .7 0l6.516 6.515a.495.495 0 0 1 0 .7L8.35 14.866a.495.495 0 0 1-.7 0L1.134 8.35a.495.495 0 0 1 0-.7L7.65 1.134Z" />
                                        </svg></p></a>

                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                    </div>
                </div>
            </div>



            <div className="album py-1">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">

                                    <div className='hoverimage1'>
                                        <Zoom>
                                            <img src={Interiorphoto} className="card-img-top image2" alt="Interiorphoto" />
                                        </Zoom>

                                        <h5 className="overlay1 mb-1"> Showroom Interior Photo</h5>



                                    </div>

                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className='hoverimage1'>
                                        <Zoom>
                                            <img src={Sareecounter} className="card-img-top image2" alt="Sareecounter" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="overlay1 mb-1"> Showroom Interior Photo</h5>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6  me-2 mt-3">
                                    <div className='hoverimage1'>
                                        <Zoom>
                                            <img src={bethuadaharishowroom} className="card-img-top image2" alt="bethuadaharishowroom" />
                                        </Zoom>
                                        <div className="card-body">
                                            <h5 className="overlay1 mb-1">Showroom Interior Photo</h5>

                                        </div>
                                    </div>
                                </div>

                                
                            </div>

                        </div>




                    </div>
                </div>
            </div>

            <div className="album py-1">
                <div className="container">
                    <div className="row">





                        <div className="col-md-12 mt-3">

                            <BethuaMap />

                        </div>
                    </div>

                </div>
            </div>


            <br />
            <br />
        </div >
    )
}

export default Bethuashop